import { useContext, useEffect, useState } from "react";
import { useAsyncValue, useNavigate, useParams } from "react-router-dom";
import { DContext } from "../../../context/Datacontext";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { HiSquaresPlus } from "react-icons/hi2";
import { IoPeopleOutline, IoPersonAddOutline } from "react-icons/io5";
import AllList from "../AllList";

import { deleteClient, deleteConfirm, fetchClient } from "../../services/managerApi/clientsApi";
import { fetchAllSpoc } from "../../services/managerApi/SPOCApis";


const ClientDetails = () => {

    const { BeURL, showAlert, showDeleteConfirm, currentUser, } = useContext(DContext)
    const navigate = useNavigate()

    const [client, setClient] = useState(null)
    const [spoc, setSpoc] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerpage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [totalSpoc, setTotalSpoc] = useState(0)


    const { clientId } = useParams()

    useEffect(() => {
        const clientData = async () => {
            await fetchClient(BeURL, showAlert, setClient, clientId)

        }

        clientData()

    }, [])


    const handleDelete = async (id) => {
        const confirm = await deleteConfirm(BeURL, showDeleteConfirm, showAlert, id)


        if (confirm)
            await deleteClient(BeURL, showAlert, id)

    }


    useEffect(() => {
        const fetchClients = async () => {
            await fetchAllSpoc(BeURL, showAlert, setSpoc, currentUser.company.companyId, clientId, currentPage, rowsPerPage, setTotalSpoc, setTotalPage)
        }

        fetchClients()
    }, [currentPage, rowsPerPage, BeURL])

    useEffect(() => {
        setCurrentPage(1)
    }, [rowsPerPage])

    // Client useState


    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPage) {
            setCurrentPage(prev => prev + 1);
        }
    };



    return (
        <main className="p-4 space-y-6">
            <h1 className="text-xl font-semibold m-3 md:px-20">Client Detail</h1>
            <section className=" md:flex md:justify-center p-4 m-6">
                {/* Client Info */}


                <div className="bg-purple-50 shadow p-4 rounded-xl md:flex md:justify-around w-full">

                    <div className="flex items-center gap-4">
                        {client?.logo ? (
                            <img src={client?.logo} alt={client?.clientName} className="h-16 w-16 rounded object-contain border" />
                        ) : (
                            <div className="h-16 w-16 rounded border flex items-center justify-center bg-gray-200 text-gray-400">No Logo</div>
                        )}
                        <div>
                            <h2 className="text-xl font-semibold text-secondary-400">{client?.clientName}</h2>
                            <p className="text-gray-600">{client?.industry.length <= 2 ? client?.industry.toUpperCase() : client?.industry.charAt(0).toUpperCase() + client?.industry.slice(1)}</p>
                        </div>
                    </div>


                    <div>
                        <p className="text-gray-600 font-medium">Website Link :</p>
                        <p className="text-primary-500">{client?.clientWebsite || '-'}</p></div>

                    {(currentUser.role === 'admin' || currentUser.role === 'manager') && <div className="flex items-center gap-5">
                        <FaRegEdit className='text-lg text-primary-500 ' title="Update client" onClick={() => navigate(`/update-client/${client?._id}`)} />
                        {currentUser.role === 'admin' && <MdOutlineDeleteOutline className='text-lg text-red-500 ' title="Delete client" onClick={() => handleDelete(client?._id)} />}
                        <IoPersonAddOutline className="text-secondary-400 text-lg" title="Create SPOC" onClick={() => navigate(`/create-spoc/${client?._id}`)} />
                    </div>}
                </div>

            </section>
            {/* SPOC List */}
            <section className=" p-4   m-6">
                <h1 className="text-xl font-semibold md:px-14 ">SPOC Details</h1>

                <AllList spoc={spoc} />

                <div>
                    {/* Pagination Controls */}
                    <div className=" mx-auto mt-3 flex justify-around items-center">
                        <div className="flex items-center gap-2">
                            <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
                            <select
                                id="recordsPerPage"
                                value={rowsPerPage}
                                onChange={e => setRowsPerpage(parseInt(e.target.value, 10))}
                                className="ml-2 px-3 py-1 border rounded"
                            >
                                {[10, 20, 25, 50, 75, 100].map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                            </select>
                        </div>
                        <div className="text-sm">Total SPOC: {totalSpoc}</div>
                    </div>
                    <div className="flex justify-center items-center gap-4">
                        <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => handlePagination('prev')}
                            disabled={currentPage === 1}
                        >
                            chevron_left
                        </span>
                        <span>{currentPage} of {totalPage}</span>
                        <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPage ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => handlePagination('next')}
                            disabled={currentPage === totalPage}
                        >
                            chevron_right
                        </span>
                    </div>
                </div>


            </section>

            {/* Pagination  */}


        </main >
    );
};

export default ClientDetails;
